import { render, staticRenderFns } from "./TopPensionFundsTable.vue?vue&type=template&id=d5ce965c&scoped=true"
import script from "./TopPensionFundsTable.vue?vue&type=script&lang=js"
export * from "./TopPensionFundsTable.vue?vue&type=script&lang=js"
import style0 from "./TopPensionFundsTable.vue?vue&type=style&index=0&id=d5ce965c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ce965c",
  null
  
)

export default component.exports